// extracted by mini-css-extract-plugin
module.exports = {"mainColorStyle":"I0_N0_Rf"};